module.exports = __webpack_public_path__ + "img/a.bb199701.jpg";